import { IconButton } from "@mui/material";

import { DeleteSweepIcon } from "@/shared/foundation/icons/mui";

import type { BabylonManager } from "./BabylonManager";

interface ClearMeasurementsButtonProps {
  manager: BabylonManager | null;
  /**
   * True when a clear would remove something: a completed measurement, or
   * an anchor still waiting for its second point. A lone anchor counts
   * because its dot stays in the scene until cleared.
   */
  canClear: boolean;
}

/**
 * Header control that removes every completed measurement and any pending
 * anchor. Renders only while there is something to clear. Imperative like
 * the recenter button: measurements are manager state, not panel config.
 */
export function ClearMeasurementsButton({
  manager,
  canClear,
}: ClearMeasurementsButtonProps) {
  if (!canClear) {
    return null;
  }
  // No disabled state: `canClear` is only true after the manager reports a
  // measure overlay, so a manager always exists when this renders.
  return (
    <IconButton
      aria-label="Clear measurements"
      onClick={() => manager?.clearMeasurements()}
      size="small"
      title="Clear measurements"
    >
      <DeleteSweepIcon color="inherit" fontSize="small" />
    </IconButton>
  );
}
